import { useState, useEffect } from "react";
import { useDebounce } from "../../../hooks/useDebounce";
import useTableCtx from "../tableContext/useTableCtx";
import ExpandableTableSearch from "./ExpandableTableSearch";

const TableSearch = ({
  value,
  label,
  withSearch,
}: {
  value: string;
  label?: string;
  withSearch?:
    | boolean
    | {
        placeholder?: string;
        withoutSearchIcon?: boolean;
        withoutSearchClear?: boolean;
        searchDelay?: number;
      };
}) => {
  const { placeholder, withoutSearchIcon, withoutSearchClear, searchDelay } = (
    typeof withSearch === "object" ? withSearch : {}
  ) as {
    placeholder?: string;
    withoutSearchIcon?: boolean;
    withoutSearchClear?: boolean;
    searchDelay?: number;
  };
  const { tableSearch, handleTableSearch } = useTableCtx()!;

  const contextValue = String(tableSearch?.[value] ?? "");

  const [searchTerm, setSearchTerm] = useState<string>(contextValue);

  const debouncedSearchTerm = useDebounce(searchTerm, searchDelay || 1000);

  useEffect(() => {
    if (contextValue !== searchTerm) {
      setSearchTerm(contextValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue]);

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && debouncedSearchTerm !== null) {
      handleTableSearch(value, debouncedSearchTerm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm]);

  return (
    <ExpandableTableSearch
      label={label ?? value}
      placeholder={placeholder}
      value={searchTerm || ""}
      onChange={setSearchTerm}
      withoutSearchIcon={withoutSearchIcon}
      withoutSearchClear={withoutSearchClear}
    />
  );
};

export { TableSearch };
